import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBox = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18.4971 2C19.3581 2 20.1204 2.51622 20.4402 3.31541L21.8501 6.84012C21.9491 7.08676 22 7.3493 22 7.61773V19.907C22 21.0607 21.0607 22 19.907 22H4.09302C2.93887 22 2 21.0607 2 19.907V7.61773C2 7.35065 2.05042 7.08903 2.14989 6.84012L3.55977 3.31541C3.87919 2.51622 4.64186 2 5.50291 2H18.4971ZM3.39535 19.907C3.39535 20.2912 3.70831 20.6047 4.09302 20.6047H19.907C20.2912 20.6047 20.6047 20.2912 20.6047 19.907V8.74419H16.186V14.3256L12.2834 12.5914C12.1046 12.5124 11.8977 12.5116 11.7166 12.5914L7.81395 14.3256L7.84393 8.74419H3.39535V19.907ZM9.2093 12.1781L11.1497 11.316C11.6907 11.0757 12.3116 11.0766 12.8503 11.316L14.7907 12.1781V8.74419H9.2093V12.1781ZM16.1461 7.34884H20.5501L19.1448 3.83321C19.0384 3.56727 18.784 3.39535 18.4971 3.39535H14.8007L16.1461 7.34884ZM9.29106 7.34884H14.7089L13.3336 3.39535H10.6664L9.29106 7.34884ZM5.50291 3.39535C5.21599 3.39535 4.96203 3.56727 4.8552 3.83321L3.44895 7.34884H7.8512L7.85211 7.2371L9.18932 3.39535H5.50291Z",
		fillRule: "evenodd",
		clipRule: "evenodd",
		fill: "currentColor"
	})
});
export default SvgBox;
